import { useTranslation } from "react-i18next";
import { formatDateSr } from "@normax-performance/shared-format";
import { Button } from "../../../shared-ui/primitives";
import { computeQuickPeriod, type AnalyticsPeriodRange } from "../period";

export interface AnalyticsEmptyStateProps {
  period: AnalyticsPeriodRange;
  onChangePeriod: (period: AnalyticsPeriodRange) => void;
}

/**
 * Zero-data period state (this slice's spec §23) — deliberately NOT a
 * dashboard full of 0/0/0/0 (docs/.../FORENSIC_PRODUCT_BRIEF.md's own
 * empty-state reasoning). No write/create action — Analytics is read-only.
 */
export function AnalyticsEmptyState({ period, onChangePeriod }: AnalyticsEmptyStateProps) {
  const { t } = useTranslation("analytics");

  return (
    <div className="nx-analytics__empty">
      <p className="nx-analytics__empty-title">{t("empty.title")}</p>
      <p>
        {formatDateSr(period.from)} — {formatDateSr(period.to)}
      </p>
      <p>{t("empty.hint")}</p>
      <div className="nx-analytics__empty-actions">
        <Button variant="secondary" onClick={() => onChangePeriod(computeQuickPeriod("yesterday", new Date()))}>
          {t("empty.quickActionYesterday")}
        </Button>
        <Button variant="secondary" onClick={() => onChangePeriod(computeQuickPeriod("thisMonth", new Date()))}>
          {t("empty.quickActionThisMonth")}
        </Button>
      </div>
    </div>
  );
}
